import { createLink } from "@tanstack/react-router"
import type { ComponentProps } from "react"
import { IconButton } from "@motleyhand/design"

const IconButtonLink = createLink(
  ({ key, ...props }: ComponentProps<typeof IconButton>) => (
    <IconButton key={key} {...props} />
  ),
)

export default IconButtonLink
